import { createFileRoute, redirect } from '@tanstack/react-router';
import { getActiveBrandId } from '../lib/active-brand.js';
import { brandsQuery, meQuery } from '../lib/queries.js';

export const Route = createFileRoute('/onboarding/url')({
  beforeLoad: async ({ context: { queryClient } }) => {
    const me = await queryClient.ensureQueryData(meQuery());
    if (!me) throw redirect({ to: '/login' });
    const brands = await queryClient.ensureQueryData(brandsQuery());
    const live = brands.filter((b) => b.archivedAt === null);
    const activeId = getActiveBrandId();
    const target = live.find((b) => b.id === activeId) ?? live[0];
    if (!target) throw redirect({ to: '/brands' });
    throw redirect({ to: '/brand/$slug/onboarding/url', params: { slug: target.slug } });
  },
  component: () => null,
});
